export default __webpack_public_path__ + "static/media/photo-3.72c278b1.jpg";